import trampled from './audio/trampled.mp3';
import blackdog from './audio/blackdog.mp3';
import breakdown from './audio/breakdown.mp3';
import heart from './audio/heart.mp3';
import immsong from './audio/immsong.mp3';
import levee from './audio/levee.mp3';
import ramble from './audio/ramble.mp3';
import rocknroll from './audio/rocknroll.mp3';



export const trackInfo = [
  {
    id: 0,
    name: "Communication Breakdown",
    src: breakdown,
    time: '2:28'
  },
  {
    id: 1,
    name: "Ramble On",
    src: ramble,
    time: '4:28'
  },
  {
    id: 2,
    name: "Heartbreaker",
    src: heart,
    time: '4:15'
  },
  {
    id: 3,
    name: "Immigrant Song",
    src: immsong,
    time: '2:26'
  },
  {
    id: 4,
    name: "Rock n Roll",
    src: rocknroll,
    time: '3:40'
  },
  {
    id: 5,
    name: "Black Dog",
    src: blackdog,
    time: '4:55'
  },
  {
    id: 6,
    name: "When the Levee Breaks",
    src: levee,
    time: '7:10'
  },
  {
    id: 7,
    name: "Trampled Under Foot",
    src: trampled,
    time: '5:36'
  }
];